// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalLink_root__Cmqym","list":"ModalLink_list__3t2tC","spinAround":"ModalLink_spinAround__1Qij7"};